import { Share, X } from "lucide-react";
import { useInstallPrompt } from "./useInstallPrompt";

function IconaApp() {
  return (
    <img
      src="/app-icons/icon-192.png"
      alt=""
      className="w-11 h-11 rounded-[11px] shrink-0"
    />
  );
}

export function InstallPrompt() {
  const { modo, chiudi, installa } = useInstallPrompt();

  if (!modo) return null;

  if (modo === "android") {
    return (
      <div className="fixed inset-x-3 bottom-4 z-[60] bg-card border border-border rounded-2xl p-4 shadow-xl animate-in fade-in slide-in-from-bottom-4 duration-200">
        <div className="flex items-start gap-3">
          <IconaApp />
          <div className="flex-1">
            <p className="font-semibold text-[15px] leading-snug">Tieni AIEnergia sul telefono</p>
            <p className="text-[13px] text-muted-foreground mt-1 leading-snug">
              Si apre come un'app, senza cercare il sito ogni volta.
            </p>
          </div>
        </div>
        <div className="flex gap-2 mt-4">
          <button
            type="button"
            onClick={installa}
            className="flex-1 min-h-[44px] rounded-full bg-brand text-white font-semibold text-[15px] hover:bg-brand-dark transition-colors"
          >
            Aggiungi
          </button>
          <button
            type="button"
            onClick={chiudi}
            className="min-h-[44px] px-5 rounded-full border border-border text-muted-foreground font-medium text-[15px] hover:bg-surface transition-colors"
          >
            Non ora
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[60] flex items-end">
      <button
        type="button"
        aria-label="Chiudi"
        onClick={chiudi}
        className="absolute inset-0 bg-dark/45 animate-in fade-in duration-200"
      />
      <div className="relative w-full bg-card rounded-t-[22px] px-5 pt-5 pb-8 animate-in slide-in-from-bottom duration-200">
        <button
          type="button"
          onClick={chiudi}
          aria-label="Chiudi"
          className="absolute top-3 right-3 w-11 h-11 flex items-center justify-center text-muted-foreground rounded-full hover:bg-surface transition-colors"
        >
          <X size={20} />
        </button>

        <div className="flex items-start gap-3 mb-5 pr-10">
          <IconaApp />
          <div>
            <p className="font-semibold text-[16px] leading-snug">Tieni AIEnergia sul telefono</p>
            <p className="text-[13px] text-muted-foreground mt-1 leading-snug">Tre tocchi, una volta sola.</p>
          </div>
        </div>

        <ol className="space-y-3.5">
          <li className="flex items-center gap-3">
            <span className="w-[26px] h-[26px] shrink-0 rounded-full bg-brand text-white text-[13px] font-semibold flex items-center justify-center">
              1
            </span>
            <span className="text-[14px] leading-snug">
              Tocca <Share size={15} className="inline align-[-2px] text-[#007AFF]" /> in fondo a
              Safari
            </span>
          </li>
          <li className="flex items-center gap-3">
            <span className="w-[26px] h-[26px] shrink-0 rounded-full bg-brand text-white text-[13px] font-semibold flex items-center justify-center">
              2
            </span>
            <span className="text-[14px] leading-snug">
              Scorri e scegli <b>Aggiungi a Home</b>
            </span>
          </li>
          <li className="flex items-center gap-3">
            <span className="w-[26px] h-[26px] shrink-0 rounded-full bg-brand text-white text-[13px] font-semibold flex items-center justify-center">
              3
            </span>
            <span className="text-[14px] leading-snug">
              Tocca <b>Aggiungi</b> in alto a destra
            </span>
          </li>
        </ol>

        <button
          type="button"
          onClick={chiudi}
          className="w-full min-h-[48px] mt-6 rounded-full border border-border text-muted-foreground font-semibold text-[15px] hover:bg-surface transition-colors"
        >
          Ho capito
        </button>
      </div>
    </div>
  );
}
